import { Component } from '@angular/core';
import data from '../../../data/navigation.json';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-header-three',
  templateUrl: './header-three.component.html',
  styleUrls: ['./header-three.component.css']
})
export class HeaderThreeComponent extends HelperService {
  public navigation = data;
  constructor(public helperService: HelperService) {
    super();
  }
}
